

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./Contractor.Validator.js"

class ContractorAPI {


/*
undefinedPOST http://localhost:3000/contractors/create
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

{
    "name" : "Nhà Thầu XD ABC",
    "address":"Hà Đông, Hà Nội",
    "district":"Quận Hà Đông",
    "city":"Thành Phố Hà Nội",
    "country":"Việt Nam",
    "phone":"09352543242",
    "email":"abc@gmail.com",
    "taxCode":"54543544",
    "origination":"Việt Nam",
    "foundedYear":2010,
    "typeOfContractor":["1.1","1.1.1"],
    "typeOfConstruction":["Xây mới"]
}


*/


  create = async (data) => {
    const validator = Validator.VALIDATION_CONTRACTORS_CREATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/contractors/create", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


GET http://localhost:3000/contractors/detail/214500795244
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw


*/


  detail = async (id) => {
    const validator = Validator.VALIDATION_CONTRACTORS_DETAIL_ONE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    const result = await Request.get(HOST + `/contractors/detail/${id}`, { id });
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/contractors/update/214500795244
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
  "name": "Nhà Thầu",
   "typeOfContractor": [
        "1.1","1.2.1"
      ]
}


*/


  update = async (id, data) => {
    const validator = Validator.VALIDATION_CONTRACTORS_UPDATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    const result = await Request.post(HOST + `/contractors/update/${id}`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*



POST http://localhost:3000/contractors/search
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

{
    "name" : "Nhà Thầu",
    "typeOfContractor":["1.1","1.1,1.1.1"],
    "typeOfConstruction":["Xây mới"],
    "orderBy":"updatedAt",
    "orderType":"DESC",
//    "filterFollow":true,
    "revenue":100000000
}


*/


  search = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if (result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/contractors/search", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/contractors/214500795244/createProjectExperience
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "name" : "Dự án kinh nghiệm",
    "address":"Hà Đông, Hà Nội",
    "district":"Quận Hà Đông",
    "city":"Thành Phố Hà Nội",
    "country":"Việt Nam",
    "projectType":"Hotel",
    "projectSubType":"5 star"
}


*/


  createProjectExperience = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/contractors/214500795244/createProjectExperience", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/contractors/updateHouseLinkEvaluation
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "id":"214500795244",
    "isHouseLinkMember" : true,
    "totalRanking" : 4,
    "houselinkRanking" : []
}

*/


  updateHouseLink = async (data) => {
    const validator = Validator.VALIDATION_UPDATE_HOUSELINK_EVALUATION;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    const result = await Request.post(HOST + "/contractors/updateHouseLink", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/contractors/approve
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "id":"214500795244",
    "approved" : true
}

*/


  approve = async (data) => {
    const validator = Validator.VALIDATION_APPROVED_CONTRACTOR;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) throw new Error(result.error);
    }
    let result = await Request.post(HOST + "/contractors/approve", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/contractors/adminList
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

{
    "name" : "Nhà Thầu",
    "typeOfContractor":["1.1","1.1,1.1.1"],
    "typeOfConstruction":["Xây mới"],
    "orderBy":"updatedAt",
    "orderType":"DESC",
    "approved":false,
    "revenue":100000000
}


*/


  adminList = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/contractors/adminList", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


  /*
    POST http://api.houselink.com:3000/contractors/deactive
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

    {
        "id":"246238911134"
    }
  */

  deactive = async (data) => {
    const validator = Validator.VALIDATION_DEACTIVE_CONTRACTOR;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/contractors/deactive", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  deactive = async (data) => {
    const validator = Validator.VALIDATION_DEACTIVE_CONTRACTOR;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/contractors/deactive", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  importOldSystem = async (id) => {
    // const validator = Validator.VALIDATION_DEACTIVE_CONTRACTOR;
    // if(validator !== false && !!validator.body) {
    //   const result = Joi.validate(data, validator.body);
    //   if (result.error !== null) {
    //     return { validateError: result.error.details[0].message }
    //   }
    // }
    let result = await Request.post(HOST + "/contractors/importOldSystem", {id});
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  searchByOldId = async (id) => {
    // const validator = Validator.VALIDATION_DEACTIVE_CONTRACTOR;
    // if(validator !== false && !!validator.body) {
    //   const result = Joi.validate(data, validator.body);
    //   if (result.error !== null) {
    //     return { validateError: result.error.details[0].message }
    //   }
    // }
    let result = await Request.post(HOST + "/contractors/searchByOldId", {id});
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  } 
}
export default new ContractorAPI();



// WEBPACK FOOTER //
// ./src/services/contractor/Contractor.API.js